// pages/support/SupportPage.tsx
import React from 'react';
import { Card, Typography, Space, Divider, Row, Col } from 'antd';
import {
  GlobalOutlined,
  MailOutlined,
  PhoneOutlined,
  ClockCircleOutlined,
  EnvironmentOutlined,
} from '@ant-design/icons';

const { Title, Text, Paragraph } = Typography;

const SupportPage = () => {
  return (
    <div style={{ padding: 24, maxWidth: 1200, margin: '0 auto' }}>
      <Card>
        <Title level={2}>Support & Contact - Adriatic Project</Title>
        <Divider />

        <Space direction="vertical" size="large" style={{ width: '100%' }}>
          {/* Contact Information */}
          <section>
            <Title level={3}>Contact Information</Title>
            <Paragraph>
              For support or inquiries about Adriatic Project's luxury apartments and services, please contact us:
            </Paragraph>
            <Space direction="vertical">
              <Text>
                <MailOutlined /> Email: info@adriatic-project.com
              </Text>
              <Text>
                <PhoneOutlined /> Phone: 045 557 555
              </Text>
              <Text>
                <GlobalOutlined /> Website: adriatic-project.com
              </Text>
              <Text>
                <ClockCircleOutlined /> Office Hours: Monday - Friday, 9:00 AM - 5:00 PM
              </Text>
            </Space>
          </section>

          <Divider />

          {/* App Support */}
          <section>
            <Title level={3}>Application Support</Title>
            <Row gutter={[24, 24]}>
              <Col xs={24} md={12}>
                <Card title="Account Access" bordered={false}>
                  <Paragraph>
                    Access the app at app.adriatic-project.com. For login issues or password reset, use the "Forgot
                    Password" option or contact your administrator.
                  </Paragraph>
                </Card>
              </Col>
              <Col xs={24} md={12}>
                <Card title="Technical Support" bordered={false}>
                  <Paragraph>
                    For technical assistance, please contact us with your username and a detailed description of the
                    issue you're experiencing.
                  </Paragraph>
                </Card>
              </Col>
            </Row>
          </section>

          <Divider />

          {/* Office Location */}
          <section>
            <Title level={3}>Visit Us</Title>
            <Space direction="vertical">
              <Text>
                <EnvironmentOutlined /> Adriatic Project
              </Text>
              <Text style={{ marginLeft: 24 }}>Bulevardi Teuta</Text>
              <Text style={{ marginLeft: 24 }}>Ulcinj, Montenegro</Text>
            </Space>
          </section>

          <Divider />

          {/* About */}
          <section>
            <Title level={3}>About Adriatic Project</Title>
            <Paragraph>
              Adriatic Project specializes in luxury apartments along the Adriatic Sea. Our property management
              application helps streamline operations and provide excellent service to our clients.
            </Paragraph>
          </section>
        </Space>
      </Card>
    </div>
  );
};

export default SupportPage;
